import React, {useEffect} from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import AdminPage from "./mainPages/AdminPage";
import {useTypedSelector} from "./store";
import AuthPage from "./mainPages/auth/AuthPage";

function App() {
    useEffect(()=>{
        document.title='Админ панель'
    })
    const {isAuth} = useTypedSelector(state => state.auth)
    return (
        <>
            <Routes>
                <Route path={`/auth/*`} element={<AuthPage/>}/>
                <Route path={`/app/*`} element={isAuth ? <AdminPage/> : <Navigate to="/auth/"/>}/>
                <Route
                    path="*"
                    element={<Navigate to='/app'/>}
                />
            </Routes>
        </>


    );
}

export default App;
